import { useLocation, useNavigate, type Location } from "react-router-dom";

function getBackgroundLocation(state: unknown): Location<unknown> | undefined {
  if (!state || typeof state !== "object" || !("overlayBackground" in state)) return;
  const background = state.overlayBackground;
  if (
    !background || typeof background !== "object"
    || !("pathname" in background) || typeof background.pathname !== "string"
    || !("search" in background) || typeof background.search !== "string"
    || !("hash" in background) || typeof background.hash !== "string"
    || !("key" in background) || typeof background.key !== "string"
    || !("state" in background)
  ) return;

  return {
    pathname: background.pathname,
    search: background.search,
    hash: background.hash,
    key: background.key,
    state: background.state,
  };
}

export function useRouteOverlay(fallbackPath: string) {
  const location = useLocation();
  const navigate = useNavigate();
  const backgroundLocation = getBackgroundLocation(location.state);

  const openOverlay = (path: string, opener?: HTMLElement) => {
    // Safari does not focus buttons on pointer activation. Give the dialog a
    // reliable return target before it captures the previously focused element.
    opener?.focus({ preventScroll: true });
    navigate(path, { state: { overlayBackground: location } });
  };
  const closeOverlay = () => {
    if (backgroundLocation) navigate(-1);
    else navigate(fallbackPath, { replace: true });
  };

  return { backgroundLocation, openOverlay, closeOverlay };
}
